export default "__VITE_ASSET__DIeC$7Mf__"